// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"36":"6c023b2f0e6d6733","225":"7421bc030086f265"}[chunkId] + ".js";
};